var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.707 28.293-5.6989-5.699a12.5327 12.5327 0 1 0 -1.4141 1.4141l5.699 5.6989a1 1 0 0 0 1.414-1.414zm-15.207-3.293a10.5 10.5 0 1 1 10.5-10.5 10.5118 10.5118 0 0 1 -10.5 10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.51 10.1426a5.6045 5.6045 0 0 0 -4.5627-2.8926 6.4705 6.4705 0 0 0 -.8916 0 5.6052 5.6052 0 0 0 -4.5657 2.8926 5.9483 5.9483 0 0 0 -.1318 5.6621 5.8831 5.8831 0 0 0 .9082 1.2661l3.4936 3.8511a.999.999 0 0 0 1.48 0l3.4944-3.8519a5.796 5.796 0 0 0 .7754-6.9277zm-5.01 4.5537a1.7056 1.7056 0 1 1 1.7051-1.7056 1.7071 1.7071 0 0 1 -1.7051 1.7056z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLocation);
export default __webpack_public_path__ + "static/media/search_location.a0cec272f89303d455fea9977a69f89c.svg";
export { ForwardRef as ReactComponent };